let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Group, tokens } from '@klarna/ui';
import KovfsWarning from 'features/installments/components/kovfsWarning/KovfsWarning';
import SuperscriptedDisclosureList from 'features/installments/components/superscriptedDisclosure/SuperscriptedDisclosureList';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { useTranslate } from 'framework/utils/i18n/useTranslate';
const bodyStyles = css(t || (t = _`
  max-width: 100%;

  p,
  p > *,
  a {
    font-size: ${0}px;
    line-height: ${0}px;
    color: ${0};
  }

  a:hover,
  a:focus {
    color: ${0};
  }
`), tokens.textSizes['text/desktop/s'], tokens.lineHeights['body/desktop/s'], tokens.colors.light['text/subtle'], tokens.colors.light['text/subtle']);
/**
 * Disclaimer layout shared by every installment surface. Picks the body
 * in this precedence: `children` → superscripted list → `translationKey`
 * markdown, and stacks the KOVFS regulatory warning below.
 *
 * Returns `null` only when the picked branch has nothing to render —
 * i.e. no `children`, an empty superscripts map, and no `translationKey`.
 * A non-null but visually empty `children` (e.g. `<></>`) is treated as a
 * caller decision and rendered as-is.
 */ const InstallmentDisclaimer = ({ children, disclosureSuperscripts, translationKey, kovfsWarningPaddingHorizontal })=>{
    const translate = useTranslate();
    const body = children !== null && children !== void 0 ? children : disclosureSuperscripts && disclosureSuperscripts.size > 0 ? /*#__PURE__*/ _jsx(SuperscriptedDisclosureList, {
        disclosureSuperscripts: disclosureSuperscripts
    }) : translationKey ? /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: bodyStyles,
        children: translate(translationKey)
    }) : null;
    if (!body) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Group, {
        direction: "vertical",
        gap: "space/16",
        children: [
            body,
            /*#__PURE__*/ _jsx(KovfsWarning, {
                paddingHorizontal: kovfsWarningPaddingHorizontal
            })
        ]
    });
};
export default InstallmentDisclaimer;
